{
  "howitworks": "How it works",
  "howitworksPhrase1Part1": "It’s time to make the world a ",
  "howitworksPhrase1Part2": "little bit ",
  "howitworksPhrase1Part3": "lot better.",
  "or": "or",

  "howitworksPhrase2Part1": "Whether you have a project that is already underway ",
  "howitworksPhrase2Part2": " a vision that is still just a shimmer of an idea,",
  "howitworksPhrase2Part3": " RebelBase gives you the means to launch a different world.",

  "BuildTitle": "The real-world meets the classroom and the sparks are flying.",
  "BuildPhase1": "Take workshops ",
  "BuildPhase1TextPart1": "— bite-size,",
  "BuildPhase1TextPart2": "intuitive, they’re all you need to develop your idea. ",
  "BuildPhase1TextPart3": "Dive right in, no MBA necessary. ",

  "BuildPhase2": "Complete builders",
  "BuildPhase2TextPart1": " — apply the workshops directly to the problem you’re bent on tackling.",
  "BuildPhase2TextPart2": "Discover your solution, prove its potential,",
  "BuildPhase2TextPart3": " communicate its worth, and chart a path for it to grow.",

  "BuildPhase3": "Make mistakes",
  "BuildPhase3TextPart1": " — RebelBase is a safe place to stumble.",
  "BuildPhase3TextPart2": " Experts and community members help you learn what’s working and what’s gotta go. ",
  "signUptoBuildLink": "Sign up for free to take builders",

  "ShowcaseTitle": "Catch the eyes that matter the most.",
  "ShowcasePhase1": "Build a project page",
  "ShowcasePhase1TextPart1": " — it’s your venture at a glance. ",
  "ShowcasePhase1TextPart2": "Your profile is automatically updated with awards you win, ",
  "ShowcasePhase1TextPart3": "kudos you receive and builders you complete. ",

  "ShowcasePhase2": "Make a brilliant first impression",
  "ShowcasePhase2TextPart1": " — by pinning your accomplishments and experiences on your project page. ",
  "ShowcasePhase2TextPart2": "It’s what people will see first. Distinguish yourself, gain resources, ",
  "ShowcasePhase2TextPart3": "draw critical talent to you, raise capital, or get a job.",

  "ShowcasePhase3": "Customize your privacy settings",
  "ShowcasePhase3TextPart1": "— to pick and choose who can see what. ",
  "ShowcasePhase3TextPart2": "Keep project details a secret, share it with those you choose, or release it for all the world to see.",
  "ProjectPagesLink": "Browse project pages",

  "ConnectTitle": "It takes a village — start with a virtual one.",
  "ConnectPhase1": "Construct a dream team",
  "ConnectPhase1TextPart1": "— they’re here in RebelBase’s expansive web of partnerships and communities. ",
  "ConnectPhase1TextPart2": "Scope out talent, mentors, partners, and investors in your community and beyond. ",

  "ConnectPhase2": "Collaborate with ease",
  "ConnectPhase2TextPart1": "— using a shared online workspace. ",
  "ConnectPhase2TextPart2": "Tackle problems, upload files, and compare opinions without the stuffy confines of geography.  ",

  "ConnectPhase3": "Refine and advance",
  "ConnectPhase3TextPart1": "— based on input from peers, potential users, and industry experts. ",
  "ConnectPhase3TextPart2": "Find talent, resources and insight at demo days, hackathons, competitions and forums. "
}
